import { render, staticRenderFns } from "./ReportSatisfactionSurveys.vue?vue&type=template&id=5867887a&"
import script from "./ReportSatisfactionSurveys.vue?vue&type=script&lang=js&"
export * from "./ReportSatisfactionSurveys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports